import React from 'react';
import { BlockPicker } from 'react-color';
import { Button } from '@trevor/ui-components';
import { NICE_COLORS } from '../../util/helpers/charting-helpers';
import flex from '../../css/module/flex.css';

//
// http://casesandberg.github.io/react-color/
//
class ColorPicker extends React.Component {
  handleChangeComplete(hex) {
    if (this.props.onChange) {
      this.props.onChange(hex);
    }
  }

  render() {
    const colors = NICE_COLORS.sort(); // .slice(0, 25);
    return (
      <div className={`${flex.column} ${flex.alignItemsStart}`}>
        <BlockPicker
          triangle="hide" // options include: top or hide
          colors={colors}
          color={this.props.color}
          onChangeComplete={(color) => this.handleChangeComplete(color.hex)}
        />
        <Button
          size="small"
          className="margin-top-5"
          onClick={() => this.handleChangeComplete(null)}
        >
          Reset
        </Button>
      </div>
    );
  }
}

export default ColorPicker;
